import Int32LookupResourceListResultModel from '../../generated/types/model/resource/Int32LookupResourceListResultModel';

export default class Int32LookupResourceListResultViewModel extends Int32LookupResourceListResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
